﻿document.documentElement.classList.remove('no-js');
document.documentElement.classList.add('js');

class QuantityInput extends HTMLElement {
  connectedCallback(){
    this.querySelectorAll('button').forEach(btn => btn.addEventListener('click', () => {
      const input = this.querySelector('input');
      const current = Number(input.value || 1);
      input.value = Math.max(1, current + (btn.dataset.action === 'increase' ? 1 : -1));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }));
  }
}
customElements.define('quantity-input', QuantityInput);

/* v0785: sale-aware pricing for pendants. data-sale-percent is set on .product-info by
   the sale-window snippet only while a sale is active. Add-ons are never discounted here. */
window.CHSale = (function(){
  var el = document.querySelector('[data-sale-percent]');
  var pct = el ? parseInt(el.getAttribute('data-sale-percent'), 10) : 0;
  if(!(pct > 0)) pct = 0;
  function cents(c){ return Math.round(c * (100 - pct) / 100); }
  function fmt(c){
    var w = Math.floor(c / 100), r = c % 100;
    return '$' + String(w).replace(/\B(?=(\d{3})+(?!\d))/g, ',') + (r ? '.' + ('0' + r).slice(-2) : '');
  }
  return {
    percent: pct,
    active: pct > 0,
    cents: cents,
    fmt: fmt,
    html: function(fullText, c){ return pct > 0 ? '<s class="price-was">' + fullText + '</s> ' + fmt(cents(c)) : fullText; }
  };
})();

class ProductGallery extends HTMLElement {
  connectedCallback(){
    this.bindGallery();
    this.bindZoom();
  }

  normalizeImageUrl(url){
    if(!url) return '';
    try{
      return new URL(url, window.location.origin).pathname;
    } catch(error){
      return String(url).split('?')[0];
    }
  }

  /* v0783: video media support. Pause and hide every player; called before showing an image. */
  hideVideos(){
    const surface = this.querySelector('[data-product-zoom-surface]');
    if(surface) surface.classList.remove('is-video');
    this.querySelectorAll('[data-media-video]').forEach(wrap => {
      wrap.hidden = true;
      const video = wrap.querySelector('video');
      if(video && !video.paused){ try { video.pause(); } catch(e){} }
      const iframe = wrap.querySelector('iframe');
      if(iframe && wrap.dataset.played === 'true'){
        iframe.src = iframe.src;
        wrap.dataset.played = '';
      }
    });
    const main = this.querySelector('[data-main-image]');
    if(main) main.hidden = false;
  }

  showVideo(mediaId){
    const wrap = this.querySelector('[data-media-video="' + mediaId + '"]');
    if(!wrap) return false;
    this.hideVideos();
    const surface = this.querySelector('[data-product-zoom-surface]');
    if(surface) surface.classList.add('is-video');
    const main = this.querySelector('[data-main-image]');
    if(main) main.hidden = true;
    wrap.hidden = false;
    this.resetZoom();
    const video = wrap.querySelector('video');
    if(video){ try { const p = video.play(); if(p && p.catch) p.catch(function(){}); } catch(e){} }
    if(wrap.querySelector('iframe')) wrap.dataset.played = 'true';
    const thumbs = Array.from(this.querySelectorAll('[data-gallery-thumb]'));
    thumbs.forEach(btn => btn.setAttribute('aria-current', btn.getAttribute('data-media-id') === String(mediaId) ? 'true' : 'false'));
    return true;
  }

  setMainImage(src, alt, mediaId){
    const main = this.querySelector('[data-main-image]');
    const thumbs = Array.from(this.querySelectorAll('[data-gallery-thumb]'));
    this.hideVideos();
    if(main && src){
      main.src = src;
      main.alt = alt || main.alt || '';
      if(main.srcset) main.removeAttribute('srcset');
      if(main.sizes) main.removeAttribute('sizes');
      this.resetZoom();
    }
    const normalizedSrc = this.normalizeImageUrl(src);
    let activeThumb = null;
    if(mediaId){
      activeThumb = thumbs.find(btn => btn.getAttribute('data-media-id') === String(mediaId));
    }
    if(!activeThumb && normalizedSrc){
      activeThumb = thumbs.find(btn => this.normalizeImageUrl(btn.getAttribute('data-image')) === normalizedSrc);
    }
    if(activeThumb){
      thumbs.forEach(btn => btn.setAttribute('aria-current', 'false'));
      activeThumb.setAttribute('aria-current', 'true');
    }
  }

  bindGallery(){
    const thumbs = this.querySelectorAll('[data-gallery-thumb]');
    thumbs.forEach(btn => btn.addEventListener('click', () => {
      const mediaType = btn.getAttribute('data-media-type');
      if((mediaType === 'video' || mediaType === 'external_video') && this.showVideo(btn.getAttribute('data-media-id'))){
        return;
      }
      const src = btn.getAttribute('data-image');
      const alt = btn.getAttribute('data-alt') || btn.querySelector('img')?.getAttribute('alt') || '';
      this.setMainImage(src, alt, btn.getAttribute('data-media-id'));
    }));
  }

  resetZoom(){
    const surface = this.querySelector('[data-product-zoom-surface]');
    if(!surface) return;
    surface.classList.remove('is-zooming');
    surface.style.removeProperty('--zoom-x');
    surface.style.removeProperty('--zoom-y');
  }

  getZoomPoint(event){
    if(event.touches && event.touches.length) return event.touches[0];
    if(event.changedTouches && event.changedTouches.length) return event.changedTouches[0];
    return event;
  }

  updateZoomPosition(event){
    const surface = this.querySelector('[data-product-zoom-surface]');
    if(!surface) return;
    const point = this.getZoomPoint(event);
    const rect = surface.getBoundingClientRect();
    const x = Math.max(0, Math.min(100, ((point.clientX - rect.left) / rect.width) * 100));
    const y = Math.max(0, Math.min(100, ((point.clientY - rect.top) / rect.height) * 100));
    surface.style.setProperty('--zoom-x', `${x}%`);
    surface.style.setProperty('--zoom-y', `${y}%`);
  }

  startZoom(event){
    const surface = this.querySelector('[data-product-zoom-surface]');
    const image = this.querySelector('[data-product-zoom-image]');
    if(!surface || !image) return;
    if(surface.classList.contains('is-video')) return;
    this.updateZoomPosition(event);
    surface.classList.add('is-zooming');
  }

  bindZoom(){
    const surface = this.querySelector('[data-product-zoom-surface]');
    if(!surface || surface.dataset.zoomBound === 'true') return;
    surface.dataset.zoomBound = 'true';
    surface.addEventListener('mouseenter', event => this.startZoom(event));
    surface.addEventListener('mousemove', event => this.updateZoomPosition(event));
    surface.addEventListener('mouseleave', () => this.resetZoom());
    surface.addEventListener('touchstart', event => this.startZoom(event), { passive: true });
    surface.addEventListener('touchmove', event => this.updateZoomPosition(event), { passive: true });
    surface.addEventListener('touchend', () => this.resetZoom());
    surface.addEventListener('touchcancel', () => this.resetZoom());
  }
}

if(!customElements.get('product-gallery')){
  customElements.define('product-gallery', ProductGallery);
}

class ProductVariantPills extends HTMLElement {
  connectedCallback(){
    this.variants = this.parseVariants();
    this.bindVariantPills();
    this.updateSelectedVariant({ updateMedia: false });
  }

  parseVariants(){
    try{
      return JSON.parse(this.dataset.productVariants || '[]');
    } catch(error){
      return [];
    }
  }

  getSelectedOptions(){
    const selected = [];
    this.querySelectorAll('[data-variant-option]:checked').forEach(input => {
      const position = Number(input.dataset.optionPosition || 0);
      selected[position] = input.value;
    });
    return selected;
  }

  findVariant(selectedOptions){
    return this.variants.find(variant => {
      if(!variant || !Array.isArray(variant.options)) return false;
      return variant.options.every((optionValue, index) => selectedOptions[index] === optionValue);
    }) || null;
  }

  findVariantForInput(input){
    const selectedOptions = this.getSelectedOptions();
    selectedOptions[Number(input.dataset.optionPosition || 0)] = input.value;
    return this.findVariant(selectedOptions);
  }

  isVariantSelectable(variant){
    if(!variant) return false;
    return Object.prototype.hasOwnProperty.call(variant, 'selectable') ? variant.selectable !== false : variant.available !== false;
  }

  findSelectableVariantForOption(input){
    const position = Number(input.dataset.optionPosition || 0);
    return this.variants.find(variant => {
      if(!variant || !Array.isArray(variant.options)) return false;
      return variant.options[position] === input.value && this.isVariantSelectable(variant);
    }) || null;
  }

  findAnyVariantForOption(input){
    const position = Number(input.dataset.optionPosition || 0);
    return this.variants.find(variant => {
      if(!variant || !Array.isArray(variant.options)) return false;
      return variant.options[position] === input.value;
    }) || null;
  }

  updateOptionAvailability(){
    this.querySelectorAll('[data-variant-option]').forEach(input => {
      const selectedCombinationVariant = this.findVariantForInput(input);
      const selectableVariantForValue = this.findSelectableVariantForOption(input);
      const anyVariantForValue = this.findAnyVariantForOption(input);
      const variantForDisplay = selectedCombinationVariant || selectableVariantForValue || anyVariantForValue;
      const label = input.closest('.variant-choice') || input.closest('label');
      const status = label ? label.querySelector('[data-option-status]') : null;
      const price = label ? label.querySelector('[data-option-price]') : null;
      const unavailable = !anyVariantForValue;
      input.disabled = unavailable;
      if(label) label.classList.toggle('is-disabled', unavailable);
      if(status){
        status.hidden = true;
        status.textContent = variantForDisplay && variantForDisplay.availability_text ? variantForDisplay.availability_text : 'SOLD OUT';
      }
      if(price){
        if(window.CHSale && window.CHSale.active && variantForDisplay && typeof variantForDisplay.price_cents === 'number'){
          price.textContent = window.CHSale.fmt(window.CHSale.cents(variantForDisplay.price_cents));
        }else{
          price.textContent = variantForDisplay && variantForDisplay.price ? variantForDisplay.price : '';
        }
      }
    });
  }

  updateSelectedVariant(options = {}){
    const form = this.closest('form') || this.querySelector('form');
    const root = this.closest('.product-info') || document;
    const submit = form ? form.querySelector('[name="add"]') : null;
    const hiddenVariantId = form ? form.querySelector('[data-selected-variant-id]') : null;
    const availability = root.querySelector('[data-availability-pill]') || document.querySelector('[data-availability-pill]');
    const mainPrice = root.querySelector('[data-product-price]') || document.querySelector('[data-product-price]');
    const selectedVariant = this.findVariant(this.getSelectedOptions());
    const available = !!(selectedVariant && (Object.prototype.hasOwnProperty.call(selectedVariant, 'can_purchase') ? selectedVariant.can_purchase : selectedVariant.available));
    const price = selectedVariant && selectedVariant.price ? selectedVariant.price : '';
    const variantTitle = selectedVariant && selectedVariant.title ? selectedVariant.title : '';
    const availabilityText = selectedVariant && selectedVariant.availability_text ? selectedVariant.availability_text : (available ? 'IN STOCK' : 'SOLD OUT');

    if(hiddenVariantId && selectedVariant) hiddenVariantId.value = selectedVariant.id;
    if(mainPrice && price){
      if(window.CHSale && window.CHSale.active && selectedVariant && typeof selectedVariant.price_cents === 'number'){
        mainPrice.innerHTML = window.CHSale.html(price, selectedVariant.price_cents);
      }else{
        mainPrice.textContent = price;
      }
    }
    if(submit){
      submit.disabled = !available;
      submit.setAttribute('aria-disabled', available ? 'false' : 'true');
      submit.textContent = available ? (submit.dataset.bonusCta || 'Add to cart') : availabilityText;
    }
    document.querySelectorAll('[data-sticky-add-to-cart]').forEach(sticky => {
      const stickyButton = sticky.querySelector('[data-sticky-add-to-cart-button]');
      const stickyVariant = sticky.querySelector('[data-sticky-add-to-cart-variant]');
      const stickyPrice = sticky.querySelector('[data-sticky-add-to-cart-price]');
      if(stickyButton){
        stickyButton.disabled = !available;
        stickyButton.setAttribute('aria-disabled', available ? 'false' : 'true');
        stickyButton.textContent = available ? (submit?.dataset.bonusCta || 'Add to cart') : availabilityText;
      }
      if(stickyVariant) stickyVariant.textContent = variantTitle;
      if(stickyPrice){
        stickyPrice.textContent = (window.CHSale && window.CHSale.active && selectedVariant && typeof selectedVariant.price_cents === 'number')
          ? window.CHSale.fmt(window.CHSale.cents(selectedVariant.price_cents))
          : price;
      }
    });
    if(availability){
      availability.textContent = availabilityText;
      availability.classList.remove('is-coming-soon', 'is-available', 'is-unavailable');
      availability.classList.add(available ? 'is-available' : (availabilityText === 'Coming Soon' ? 'is-coming-soon' : 'is-unavailable'));
    }
    const stockNote = root.querySelector('[data-stock-note]') || document.querySelector('[data-stock-note]');
    if(stockNote){
      const stockQty = selectedVariant ? Number(selectedVariant.inventory_quantity) : NaN;
      const showStockNote = available && Number.isFinite(stockQty) && stockQty >= 1 && stockQty <= 5;
      stockNote.hidden = !showStockNote;
      if(showStockNote){
        stockNote.textContent = stockQty === 1 ? 'Only 1 left in this option.' : `Only ${stockQty} left in this option.`;
      }
    }
    // Keep the product's default image on first page load. Only switch the main gallery image
    // after a shopper actively selects a Metal Type option with an attached Shopify variant image.
    if(options.updateMedia === true){
      this.updateSelectedMedia(selectedVariant);
    }
    this.updateOptionAvailability();
  }

  updateSelectedMedia(selectedVariant){
    if(!selectedVariant || !selectedVariant.featured_media_url) return;
    const section = this.closest('.product-conversion-section') || document;
    const gallery = section.querySelector('product-gallery');
    if(gallery && typeof gallery.setMainImage === 'function'){
      gallery.setMainImage(
        selectedVariant.featured_media_url,
        selectedVariant.featured_media_alt || selectedVariant.title || '',
        selectedVariant.featured_media_id || null
      );
    }
  }

  bindVariantPills(){
    this.querySelectorAll('[data-variant-option]').forEach(input => {
      input.addEventListener('change', () => {
        if(input.checked){
          this.updateSelectedVariant({ updateMedia: input.hasAttribute('data-metal-option') });
          // Update the length selected label if present
          const fieldset = input.closest('[data-variant-pill-group]');
          if(fieldset){
            const labelEl = fieldset.querySelector('[data-length-selected-label]');
            if(labelEl && input.dataset.lengthLabel) labelEl.textContent = input.dataset.lengthLabel;
          }
        }
      });
    });
  }

}

if(!customElements.get('ch-variant-pills')){
  customElements.define('ch-variant-pills', ProductVariantPills);
}

class StickyAddToCart extends HTMLElement {
  connectedCallback(){
    this.mediaQuery = window.matchMedia('(max-width: 900px)');
    this.button = this.querySelector('[data-sticky-add-to-cart-button]');
    this.productInfo = this.closest('.product-info') || document;
    this.form = this.productInfo.querySelector('form[action*="/cart/add"]') || this.productInfo.querySelector('form');
    this.mainButton = this.productInfo.querySelector('[data-main-add-to-cart-button]') || this.productInfo.querySelector('.product-submit');
    this.handleScroll = this.updateVisibility.bind(this);
    this.handleResize = this.updateVisibility.bind(this);
    this.handleMainButtonMutation = this.syncFromMainButton.bind(this);

    if(this.button){
      this.button.addEventListener('click', () => this.submitProductForm());
    }

    if(this.mainButton && 'MutationObserver' in window){
      this.mainButtonObserver = new MutationObserver(this.handleMainButtonMutation);
      this.mainButtonObserver.observe(this.mainButton, { attributes:true, childList:true, subtree:true, characterData:true });
    }

    window.addEventListener('scroll', this.handleScroll, { passive:true });
    window.addEventListener('resize', this.handleResize);
    if(this.mediaQuery.addEventListener){
      this.mediaQuery.addEventListener('change', this.handleResize);
    }

    this.syncFromMainButton();
    this.updateVisibility();
  }

  disconnectedCallback(){
    window.removeEventListener('scroll', this.handleScroll);
    window.removeEventListener('resize', this.handleResize);
    if(this.mediaQuery && this.mediaQuery.removeEventListener){
      this.mediaQuery.removeEventListener('change', this.handleResize);
    }
    if(this.mainButtonObserver) this.mainButtonObserver.disconnect();
  }

  syncFromMainButton(){
    if(!this.button || !this.mainButton) return;
    this.button.disabled = this.mainButton.disabled;
    this.button.setAttribute('aria-disabled', this.mainButton.getAttribute('aria-disabled') || (this.mainButton.disabled ? 'true' : 'false'));
    this.button.textContent = this.mainButton.textContent.trim() || (this.mainButton.disabled ? 'SOLD OUT' : 'Add to cart');
  }

  submitProductForm(){
    if(!this.form || !this.button || this.button.disabled) return;
    if(typeof this.form.requestSubmit === 'function'){
      this.form.requestSubmit();
    }else{
      this.form.submit();
    }
  }

  updateVisibility(){
    if(!this.mainButton || !this.mediaQuery.matches){
      this.classList.remove('is-visible');
      this.setAttribute('aria-hidden', 'true');
      this.inert = true;
      return;
    }
    const rect = this.mainButton.getBoundingClientRect();
    const hasScrolledPastButton = rect.bottom < 0;
    this.classList.toggle('is-visible', hasScrolledPastButton);
    this.setAttribute('aria-hidden', hasScrolledPastButton ? 'false' : 'true');
    this.inert = !hasScrolledPastButton;
  }
}

if(!customElements.get('sticky-add-to-cart')){
  customElements.define('sticky-add-to-cart', StickyAddToCart);
}

/* Cross & Helm v0711 — OCU Slide Cart Drawer compatibility: add via AJAX, then notify drawer apps without blocking their listeners. */
(function initOcuCartDrawerCompatibility(){
  function isProductPage(){
    return document.body && document.body.classList.contains('template-product');
  }

  function getProductForms(){
    return Array.from(document.querySelectorAll('form.product-form--v18, form[action*="/cart/add"]'))
      .filter(form => form && form.tagName === 'FORM' && form.querySelector('[name="add"]'));
  }

  function setSubmitting(form, submitting){
    const submit = form.querySelector('[data-main-add-to-cart-button], [name="add"]');
    if(!submit) return;
    if(submitting){
      submit.dataset.originalText = submit.textContent;
      submit.disabled = true;
      submit.setAttribute('aria-disabled', 'true');
      submit.textContent = 'Adding...';
    }else{
      submit.disabled = false;
      submit.setAttribute('aria-disabled', 'false');
      submit.textContent = submit.dataset.originalText || 'Add to cart';
      delete submit.dataset.originalText;
    }
  }

  function updateHeaderCartCount(cart){
    if(!cart || typeof cart.item_count === 'undefined') return;
    const cartLink = document.querySelector('.header-cart-link');
    if(!cartLink) return;
    let count = cartLink.querySelector('.header-cart-link__count');
    if(cart.item_count > 0){
      if(!count){
        count = document.createElement('span');
        count.className = 'header-cart-link__count';
        cartLink.appendChild(count);
      }
      count.textContent = cart.item_count;
      count.setAttribute('aria-label', `${cart.item_count} items in cart`);
    }else if(count){
      count.remove();
    }
  }

  function notifyCartDrawerApps(item, cart){
    // Open our custom cart drawer instead of the OCU app
    if(window.CHCartDrawer && typeof window.CHCartDrawer.open === 'function'){
      window.CHCartDrawer.open();
    }
  }

  async function handleSubmit(event){
    const form = event.currentTarget;
    if(!form || form.dataset.ocuCartCompatSubmitting === 'true' || event.defaultPrevented) return;
    const submit = form.querySelector('[data-main-add-to-cart-button], [name="add"]');
    if(submit && submit.disabled) return;

    event.preventDefault();
    form.dataset.ocuCartCompatSubmitting = 'true';
    setSubmitting(form, true);

    try{
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: new FormData(form),
        credentials: 'same-origin'
      });
      if(!response.ok) throw new Error('Cart add request failed');
      const item = await response.json();
      // v38: the drawer reads the cart itself (and updates the header count), so open it straight away.
      if(window.CHCartDrawer && typeof window.CHCartDrawer.open === 'function'){
        notifyCartDrawerApps(item, null);
      }else{
        let cart = null;
        try{
          const cartResponse = await fetch('/cart.js', { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' });
          if(cartResponse.ok) cart = await cartResponse.json();
        }catch(cartError){
          cart = null;
        }
        updateHeaderCartCount(cart);
      }
    }catch(error){
      form.removeEventListener('submit', handleSubmit);
      if(typeof form.requestSubmit === 'function'){
        form.requestSubmit();
      }else{
        form.submit();
      }
      return;
    }finally{
      window.setTimeout(() => {
        delete form.dataset.ocuCartCompatSubmitting;
        setSubmitting(form, false);
      }, 250);
    }
  }

  function bindForms(){
    if(!isProductPage()) return;
    getProductForms().forEach(form => {
      if(form.dataset.ocuCartCompatBound === 'true') return;
      form.dataset.ocuCartCompatBound = 'true';
      form.addEventListener('submit', handleSubmit);
    });
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', bindForms, { once:true });
  }else{
    bindForms();
  }
})();

(function(){
  const disclaimerPhrases = [
    'this item is a deferred, subscription, or recurring purchase',
    'authorize you to charge my payment method',
    'prices, frequency and dates listed on this page until my order is fulfilled or i cancel'
  ];

  function isProductPage(){
    return document.body && document.body.classList.contains('template-product');
  }

  function containsSubscriptionDisclaimer(text){
    const normalized = String(text || '').replace(/\s+/g, ' ').trim().toLowerCase();
    return disclaimerPhrases.some(phrase => normalized.includes(phrase));
  }

  function hideDisclaimerElement(element){
    if(!element || element.nodeType !== 1) return false;
    if(element.matches('form, button, input, select, textarea, ch-variant-pills, quantity-input, sticky-add-to-cart')) return false;
    if(element.classList && element.classList.contains('product-form--v18')) return false;
    element.setAttribute('data-ch-subscription-disclaimer-removed', 'true');
    element.setAttribute('aria-hidden', 'true');
    element.hidden = true;
    element.style.setProperty('display', 'none', 'important');
    element.style.setProperty('visibility', 'hidden', 'important');
    element.style.setProperty('height', '0', 'important');
    element.style.setProperty('margin', '0', 'important');
    element.style.setProperty('padding', '0', 'important');
    element.style.setProperty('overflow', 'hidden', 'important');
    return true;
  }

  function removeInjectedSubscriptionDisclaimer(){
    if(!isProductPage()) return;
    const scopes = document.querySelectorAll('.product-form--v18, .product-info--v18, .product-conversion-section--v18');
    scopes.forEach(scope => {
      const candidates = Array.from(scope.querySelectorAll('p, div, span, small, label, section, aside'))
        .filter(element => containsSubscriptionDisclaimer(element.textContent))
        .sort((a, b) => a.textContent.length - b.textContent.length);
      if(candidates.length){
        hideDisclaimerElement(candidates[0]);
      }
    });
  }

  function initSubscriptionDisclaimerRemoval(){
    removeInjectedSubscriptionDisclaimer();
    window.setTimeout(removeInjectedSubscriptionDisclaimer, 250);
    window.setTimeout(removeInjectedSubscriptionDisclaimer, 1000);

    if(!('MutationObserver' in window) || !document.body) return;
    const observer = new MutationObserver(() => removeInjectedSubscriptionDisclaimer());
    observer.observe(document.body, { childList:true, subtree:true, characterData:true });
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', initSubscriptionDisclaimerRemoval, { once:true });
  }else{
    initSubscriptionDisclaimerRemoval();
  }
})();

/* Mobile sticky launch-list CTA visibility: show only after the actual launch-list section */
(function initMobileLaunchStickyCta(){
  const element = document.querySelector('[data-launch-sticky-cta]');
  if(!element) return;

  const launchSection = document.getElementById('launch-form-primary');
  const formsAndFooter = Array.from(document.querySelectorAll('.launch-form-bottom, .launch-form, .site-footer, footer'));
  const mediaQuery = window.matchMedia('(max-width: 620px)');

  function setState(){
    if(!mediaQuery.matches){
      element.classList.remove('is-visible', 'is-suppressed');
      element.setAttribute('aria-hidden', 'true');
      return;
    }

    const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
    const launchRect = launchSection && launchSection.getBoundingClientRect ? launchSection.getBoundingClientRect() : null;
    const hasPassedLaunchSection = launchRect ? launchRect.bottom <= 0 : false;
    const stickyReserve = Math.max(76, element.offsetHeight || 76);

    const nearInlineFormOrFooter = formsAndFooter.some((target) => {
      if(!target || target === element || !target.getBoundingClientRect) return false;
      const targetRect = target.getBoundingClientRect();
      const entersBottomZone = targetRect.top < viewportHeight && targetRect.bottom > viewportHeight - stickyReserve * 1.35;
      const largeVisibleForm = targetRect.top < viewportHeight * .78 && targetRect.bottom > viewportHeight * .45;
      return entersBottomZone || largeVisibleForm;
    });

    element.classList.toggle('is-visible', hasPassedLaunchSection);
    element.classList.toggle('is-suppressed', nearInlineFormOrFooter);
    element.setAttribute('aria-hidden', hasPassedLaunchSection && !nearInlineFormOrFooter ? 'false' : 'true');
  }

  let ticking = false;
  function requestState(){
    if(ticking) return;
    ticking = true;
    window.requestAnimationFrame(() => {
      ticking = false;
      setState();
    });
  }

  setState();
  window.addEventListener('scroll', requestState, { passive: true });
  window.addEventListener('resize', requestState);
  if(mediaQuery.addEventListener){
    mediaQuery.addEventListener('change', requestState);
  }else if(mediaQuery.addListener){
    mediaQuery.addListener(requestState);
  }
})();


/* Cross & Helm v0709 — Kaching Bundles compatibility marker for async app injection. */
(function initKachingBundlesCompatibility(){
  function isProductPage(){
    return document.body && document.body.classList.contains('template-product');
  }

  function elementLooksLikeKaching(element){
    if(!element || element.nodeType !== 1) return false;
    const signature = [
      element.tagName,
      element.id,
      element.className,
      element.getAttribute('data-kaching'),
      element.getAttribute('data-app'),
      element.getAttribute('data-app-name'),
      element.getAttribute('data-block-handle')
    ].filter(Boolean).join(' ').toLowerCase();
    return signature.includes('kaching');
  }

  function containsKaching(root){
    if(!root || !root.querySelectorAll) return false;
    if(elementLooksLikeKaching(root)) return true;
    return Array.from(root.querySelectorAll('*')).some(elementLooksLikeKaching);
  }

  function getKachingRootElements(root){
    if(!root || !root.querySelectorAll) return [];
    const matches = Array.from(root.querySelectorAll('[class*="kaching" i], [id*="kaching" i], [data-kaching], [data-app*="kaching" i], [data-app-name*="kaching" i], [data-block-handle*="kaching" i], kaching-bundles, kaching-bundle'));
    return matches.filter(element => !matches.some(other => other !== element && other.contains(element)));
  }

  function moveKachingBundlesBelowAddToCart(productForm){
    if(!productForm || !productForm.querySelectorAll) return;
    const ctaRow = productForm.querySelector('.product-cta-row--v18, .product-cta-row');
    if(!ctaRow) return;
    const reassurance = productForm.querySelector('.product-reassurance-strip--v18, .product-reassurance-strip');
    const kachingElements = getKachingRootElements(productForm).filter(element => !element.contains(ctaRow));
    kachingElements.forEach(element => {
      if(element === ctaRow.nextElementSibling) return;
      productForm.insertBefore(element, reassurance || ctaRow.nextSibling);
      element.setAttribute('data-cross-helm-kaching-placement', 'below-add-to-cart-v0729');
    });
  }

  function markKachingPurchaseAreas(){
    if(!isProductPage()) return;
    const productInfos = document.querySelectorAll('.product-info--v18, .product-info');
    productInfos.forEach(productInfo => {
      const productForm = productInfo.querySelector('.product-form--v18, form[action*="/cart/add"]');
      if(productForm) moveKachingBundlesBelowAddToCart(productForm);
      const hasKaching = containsKaching(productInfo) || containsKaching(productForm);
      productInfo.classList.toggle('has-kaching-bundles', hasKaching);
      if(productForm) productForm.classList.toggle('has-kaching-bundles', hasKaching);
    });
  }

  function init(){
    markKachingPurchaseAreas();
    window.setTimeout(markKachingPurchaseAreas, 250);
    window.setTimeout(markKachingPurchaseAreas, 1000);
    window.setTimeout(markKachingPurchaseAreas, 2500);

    if(!('MutationObserver' in window) || !document.body) return;
    const observer = new MutationObserver(() => {
      window.requestAnimationFrame(markKachingPurchaseAreas);
    });
    observer.observe(document.body, { childList:true, subtree:true, attributes:true, attributeFilter:['class','id','data-kaching','data-app','data-app-name','data-block-handle'] });
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', init, { once:true });
  }else{
    init();
  }
})();

/* Cross & Helm v0763 — Buy-box add-ons: fetch interceptor.
   Any call to /cart/add.js is intercepted. If add-ons (necklaces/toning) are checked,
   the request is rewritten to include them alongside the pendant in a single JSON items array.
   This works regardless of what triggers the cart add (OCU app, theme handler, sticky bar, etc.). */
(function(){
  var originalFetch = window.fetch;

  function gatherAddonItems(){
    var items = [];
    document.querySelectorAll('[data-necklace-card]').forEach(function(card){
      var pick = card.querySelector('input[data-necklace-checkbox]:checked');
      if(!pick) return;
      var length = card.querySelector('input[data-necklace-length]:checked');
      if(length && !length.disabled) items.push({ id: parseInt(length.value, 10), quantity: 1 });
    });
    var toning = document.querySelector('input[data-toning-checkbox]:checked');
    if(toning) items.push({ id: parseInt(toning.value, 10), quantity: 1 });
    var damage = document.querySelector('input[data-damage-checkbox]:checked');
    if(damage) items.push({ id: parseInt(damage.value, 10), quantity: 1 });
    return items;
  }

  function isCartAddUrl(url){
    if(typeof url === 'string') return url.indexOf('/cart/add') !== -1;
    if(url && typeof url.url === 'string') return url.url.indexOf('/cart/add') !== -1;
    return false;
  }

  window.fetch = function(resource, init){
    var url = (typeof resource === 'string') ? resource : (resource && resource.url ? resource.url : '');
    if(url.indexOf('/cart/add') === -1) return originalFetch.apply(this, arguments);
    /* Upsell popup adds tag themselves with ch_upsell=1 — never inject PDP add-ons into those */
    if(url.indexOf('ch_upsell=1') !== -1) return originalFetch.apply(this, arguments);

    var addons = gatherAddonItems();
    if(!addons.length) return originalFetch.apply(this, arguments);

    /* We have add-ons to inject. Parse the original body to extract the pendant variant. */
    var body = init && init.body;
    var pendantId = null;
    var pendantQty = 1;

    if(body instanceof FormData){
      pendantId = parseInt(body.get('id'), 10);
      pendantQty = parseInt(body.get('quantity'), 10) || 1;
    }else if(typeof body === 'string'){
      try{
        var parsed = JSON.parse(body);
        if(parsed.items && parsed.items.length){
          /* Already a multi-item request — just append add-ons */
          parsed.items = parsed.items.concat(addons);
          var newInit = Object.assign({}, init, {
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify(parsed)
          });
          return originalFetch.call(this, resource, newInit);
        }else if(parsed.id){
          pendantId = parseInt(parsed.id, 10);
          pendantQty = parseInt(parsed.quantity, 10) || 1;
        }
      }catch(e){
        return originalFetch.apply(this, arguments);
      }
    }

    if(!pendantId) return originalFetch.apply(this, arguments);

    /* Build a combined items array */
    var items = [{ id: pendantId, quantity: pendantQty }].concat(addons);
    var newInit2 = Object.assign({}, init, {
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    });
    return originalFetch.call(this, resource, newInit2);
  };

  /* Auto-check necklace when a length or thickness is tapped */
  document.addEventListener('change', function(event){
    var input = event.target;
    if(!input || !input.closest) return;

    /* Length tapped: auto-check the necklace */
    if(input.matches('input[data-necklace-length]')){
      var card = input.closest('[data-necklace-card]');
      var pick = card ? card.querySelector('input[data-necklace-checkbox]') : null;
      if(pick && !pick.checked) pick.checked = true;
      return;
    }

    /* Thickness tapped: filter lengths, auto-select first, auto-check necklace */
    if(input.hasAttribute('data-necklace-thickness-radio')){
      var handle = input.getAttribute('data-necklace-thickness-radio');
      var card = input.closest('[data-necklace-card]');
      if(!card) return;
      var thickness = input.value;
      var lengthLabels = card.querySelectorAll('[data-addon-thickness]');
      var firstVisible = null;
      lengthLabels.forEach(function(label){
        var match = label.getAttribute('data-addon-thickness') === thickness;
        label.style.display = match ? '' : 'none';
        if(match && !firstVisible){
          var labelRadio = label.querySelector('input[data-necklace-length]');
          if(labelRadio && !labelRadio.disabled) firstVisible = label;
        }
      });
      /* Auto-select first visible length */
      if(firstVisible){
        var radio = firstVisible.querySelector('input[data-necklace-length]');
        if(radio) radio.checked = true;
      }
      /* Auto-check the necklace */
      var pick = card.querySelector('input[data-necklace-checkbox]');
      if(pick && !pick.checked) pick.checked = true;
    }
  });
})();
/* Cross & Helm v0773 — Add a necklace tile picker.
   Mirrors each tile's checkbox into an .is-selected class (reveals the option chips)
   and swaps the tile price line to the chosen length's price. Runs after the v0763
   auto-check listener, so a tapped chip has already checked the tile by the time this fires. */
(function(){
  function syncNecklaceTiles(){
    document.querySelectorAll('.necklace-tile').forEach(function(card){
      var pick = card.querySelector('.necklace-tile__pick input[type="checkbox"]');
      if(!pick) return;
      card.classList.toggle('is-selected', pick.checked);
      var priceEl = card.querySelector('[data-necklace-tile-price]');
      if(!priceEl) return;
      var length = card.querySelector('input[data-necklace-length]:checked');
      if(pick.checked && length && !length.disabled && length.hasAttribute('data-addon-price')){
        priceEl.textContent = length.getAttribute('data-addon-price');
      }else{
        priceEl.textContent = priceEl.getAttribute('data-default-line') || priceEl.textContent;
      }
    });
  }

  document.addEventListener('change', function(event){
    if(event.target && event.target.closest && event.target.closest('[data-necklace-addon], [data-toning-addon]')){
      syncNecklaceTiles();
    }
  });

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', syncNecklaceTiles, { once:true });
  }else{
    syncNecklaceTiles();
  }
})();
/* Cross & Helm v0777 — Live order total on the Add to cart button.
   The button reads "Add to cart · $189" and the dollar figure tracks pendant variant x quantity
   plus every checked add-on (necklaces, toning, damage). Prices come from data-addon-price-cents
   on the add-on inputs and price_cents in the ch-variant-pills JSON. Registered after
   the v0763 auto-check and v0773 tile-sync document listeners so checked state is settled when it runs. */
(function(){
  function formatCents(cents){
    var whole = Math.floor(cents / 100);
    var rem = cents % 100;
    var wholeText = String(whole).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return '$' + wholeText + (rem ? '.' + ('0' + rem).slice(-2) : '');
  }

  function getBaseCents(){
    var submit = document.querySelector('[data-main-add-to-cart-button]');
    var fallback = submit ? (parseInt(submit.getAttribute('data-base-price-cents'), 10) || 0) : 0;
    var hidden = document.querySelector('form[action*="/cart/add"] [data-selected-variant-id]');
    var pills = document.querySelector('ch-variant-pills[data-product-variants]');
    if(hidden && pills){
      try{
        var variants = JSON.parse(pills.dataset.productVariants || '[]');
        for(var i = 0; i < variants.length; i++){
          if(String(variants[i].id) === String(hidden.value) && typeof variants[i].price_cents === 'number'){
            return variants[i].price_cents;
          }
        }
      }catch(e){}
    }
    return fallback;
  }

  function getAddonCents(){
    var total = 0;
    document.querySelectorAll('[data-necklace-card]').forEach(function(card){
      var pick = card.querySelector('input[data-necklace-checkbox]:checked');
      if(!pick) return;
      var length = card.querySelector('input[data-necklace-length]:checked');
      if(length && !length.disabled) total += parseInt(length.getAttribute('data-addon-price-cents'), 10) || 0;
    });
    document.querySelectorAll('input[data-toning-checkbox]:checked, input[data-damage-checkbox]:checked').forEach(function(box){
      total += parseInt(box.getAttribute('data-addon-price-cents'), 10) || 0;
    });
    return total;
  }

  function renderTotal(){
    var submit = document.querySelector('[data-main-add-to-cart-button]');
    if(!submit) return;
    /* Leave sold-out text and the mid-add "Adding..." state alone */
    if(submit.disabled || submit.dataset.originalText) return;
    var qtyInput = document.querySelector('form[action*="/cart/add"] input[name="quantity"]');
    var qty = qtyInput ? Math.max(1, parseInt(qtyInput.value, 10) || 1) : 1;
    var base = getBaseCents();
    if(window.CHSale && window.CHSale.active) base = window.CHSale.cents(base);
    var total = base * qty + getAddonCents();
    var label = submit.dataset.bonusCta || 'Add to cart';
    submit.textContent = total > 0 ? label + ' · ' + formatCents(total) : label;
    var bonusTotal = document.querySelector('[data-bonus-order-total]');
    if(bonusTotal) bonusTotal.textContent = formatCents(total);
  }

  document.addEventListener('change', renderTotal);
  document.addEventListener('input', function(event){
    if(event.target && event.target.matches && event.target.matches('input[name="quantity"]')) renderTotal();
  });
  window.addEventListener('pageshow', renderTotal);

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', renderTotal, { once:true });
  }else{
    renderTotal();
  }
})();
/* Cross & Helm v0779 — Marketing add-to-cart links (replaces the EG Auto Add to cart app).
   Any site URL can carry:
     ?ch_add=VARIANTID            add one item (or VARIANTID:QTY, comma-separated for several)
     &ch_code=CODE                optionally attach a discount code to the cart
   Example: https://crossandhelm.com/?ch_add=43310684897341&ch_code=FREEGIFT
   Items are ADDED to the customer's existing cart (native /cart/ permalinks replace it),
   the code is applied via the Cart API, the cart drawer opens so the customer sees it land,
   and the parameters are stripped from the URL so refresh/share doesn't re-add.
   The ch_upsell=1 tag keeps the PDP add-on interceptor from touching these adds. */
(function(){
  function run(){
    var params;
    try { params = new URLSearchParams(window.location.search); } catch(e){ return; }
    var addParam = params.get('ch_add');
    var codeParam = params.get('ch_code');
    if(!addParam && !codeParam) return;

    var items = [];
    if(addParam){
      addParam.split(',').forEach(function(part){
        var bits = part.split(':');
        var id = parseInt(bits[0], 10);
        var qty = parseInt(bits[1], 10) || 1;
        if(id > 0) items.push({ id: id, quantity: Math.max(1, qty) });
      });
    }

    /* Strip our params immediately so a refresh or shared URL doesn't re-add */
    params.delete('ch_add');
    params.delete('ch_code');
    var clean = window.location.pathname + (params.toString() ? '?' + params.toString() : '') + window.location.hash;
    try { window.history.replaceState(null, '', clean); } catch(e){}

    var chain = Promise.resolve();
    if(items.length){
      chain = chain.then(function(){
        return fetch('/cart/add.js?ch_upsell=1', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ items: items })
        });
      });
    }
    if(codeParam){
      chain = chain.then(function(){
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ discount: codeParam })
        });
      });
    }
    chain.then(function(){
      if(items.length && window.CHCartDrawer && typeof window.CHCartDrawer.open === 'function'){
        window.CHCartDrawer.open();
      }
    }).catch(function(){ /* out-of-stock or bad id: fail quietly, the page still works */ });
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', run, { once: true });
  }else{
    run();
  }
})();

/* ---- v0789: product detail tabs under the buy box, and close the Pendant size guide on outside click / Escape ---- */
(function(){
  function initTabs(root){
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-product-tab]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-product-tab-panel]'));
    if(!tabs.length) return;
    function activate(name, focus){
      tabs.forEach(function(t){
        var on = t.getAttribute('data-product-tab') === name;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        if(on && focus) t.focus();
      });
      panels.forEach(function(p){ p.hidden = p.getAttribute('data-product-tab-panel') !== name; });
    }
    tabs.forEach(function(t, i){
      t.addEventListener('click', function(){ activate(t.getAttribute('data-product-tab'), false); });
      t.addEventListener('keydown', function(e){
        var dir = e.key === 'ArrowRight' ? 1 : (e.key === 'ArrowLeft' ? -1 : 0);
        if(!dir) return;
        e.preventDefault();
        var next = tabs[(i + dir + tabs.length) % tabs.length];
        activate(next.getAttribute('data-product-tab'), true);
      });
    });
    var initial = root.querySelector('[data-product-tab][aria-selected="true"]') || tabs[0];
    activate(initial.getAttribute('data-product-tab'), false);
  }
  function init(){
    Array.prototype.forEach.call(document.querySelectorAll('[data-product-tabs]'), function(root){
      if(root.__chTabs) return;
      root.__chTabs = true;
      initTabs(root);
    });
  }
  if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', init, { once: true }); } else { init(); }
  document.addEventListener('shopify:section:load', init);

  function closeOpenSizeGuides(except){
    Array.prototype.forEach.call(document.querySelectorAll('details.product-size-guide[open]'), function(d){
      if(except && d.contains(except)) return;
      d.removeAttribute('open');
    });
  }
  document.addEventListener('click', function(e){ closeOpenSizeGuides(e.target); });
  document.addEventListener('keydown', function(e){ if(e.key === 'Escape') closeOpenSizeGuides(null); });
})();
